module.exports = __webpack_public_path__ + "static/img/product_four.6e910b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_four.png
// module id = Ia+5
// module chunks = 1